import React, { memo } from "react";
import { handleImageError } from 'base/Utility'
const ServicesAboutThreeColSection = (props) => {
    return (
        <>
            <div className={`section section-padding-t90-b100 ${props.bgClass}`} data-bg-color="#f8faff">
                <div className="container">
                    <div className="row row-cols-lg-3 row-cols-md-3 row-cols-sm-3 row-cols-1 mb-n6 story-icon-redefined">
                        <div className="col mb-6">
                            <div className="icon-box text-center NewFormReDesign " data-vivus-hover>
                                <div className="icon">
                                    <img className="svgInject resize-image" src={props.iconOne} alt={props.altOne} onError={handleImageError} />
                                </div>
                                <div className="content">
                                    <h3 className="title">{props.titleOne}</h3>
                                    <div className="desc">
                                        <div dangerouslySetInnerHTML={{ __html: props.titleOneDesc }}></div>
                                    </div>
                                    {props.urlOne ? <a href={props.urlOne} className="link">Learn More</a> : ''}
                                </div>
                            </div>
                        </div>

                        <div className="col mb-6">
                            <div className="icon-box text-center NewFormReDesign " data-vivus-hover>
                                <div className="icon">
                                    <img className="svgInject resize-image" src={props.iconTwo} alt={props.altTwo} onError={handleImageError} />

                                </div>
                                <div className="content">
                                    <h3 className="title">{props.titleTwo}</h3>
                                    <div className="desc">
                                        <div dangerouslySetInnerHTML={{ __html: props.titleTwoDesc }}></div>
                                    </div>
                                    {props.urlTwo ? <a href={props.urlTwo} className="link">Learn More</a> : ''}
                                </div>
                            </div>
                        </div>

                        <div className="col mb-6">
                            <div className="icon-box text-center NewFormReDesign " data-vivus-hover>
                                <div className="icon">
                                    <img className="svgInject resize-image" src={props.iconThree} alt={props.altThree} onError={handleImageError} />

                                </div>
                                <div className="content">
                                    <h3 className="title">{props.titleThree}</h3>
                                    <div className="desc">
                                        <div dangerouslySetInnerHTML={{ __html: props.titleThreeDesc }}></div>
                                    </div>
                                    {props.urlThree ? <a href={props.urlThree} className="link">Learn More</a> : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}


export default memo(ServicesAboutThreeColSection);